// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zZbW","content":"styles_content__2sjTA"};